<template>
<div>
  <div class="process-box" style="border-bottom:2px solid #333333">
    <div class="process-main">
      <div class="title">{{$t('m.ermlsbwqc')}}</div>
      <div class="no-box">
        <div class="no-box-cell">
          <img src="../assets/images/1.png" alt="">
          
          <div class="registered">{{$t('m.Register')}}</div>
          <div class="text">{{$t('m.mlsbwqc')}}</div>
        </div>
        <div class="no-box-cell">
          <img src="../assets/images/2.png" alt="">
          <div class="registered">{{$t('m.sqwwmlsbwqc')}}</div>
          <div class="text">{{$t('m.nhywqc')}}</div>
        </div>
        <div class="no-box-cell">
          <img src="../assets/images/3.png" alt="">
          <div class="registered">{{$t('m.miyyc')}}</div>
          <div class="text">{{$t('m.mibhyyc')}}</div>
        </div>
        <div class="no-box-cell">
          <img src="../assets/images/4.png" alt="">
          <div  class="registered">{{$t('m.Trade')}}</div>
          <div class="text">{{$t('m.mkplyc')}}</div>
        </div>

      </div>
      <div class="btn-box">
        <el-button @click="signinhrefwai" type="success"  style="border-radius:25px!important;background:#FFCC53;border-color:#FFCC53;color:#000000;width:164px;height:48px;font-size:20px">{{$t('m.Trade')}}</el-button>
        <!-- <el-button type="success" @click="registered" style="border-radius:25px!important;background:#FFCC53;border-color:#FFCC53;color:#000000;width:184px;font-size:20px">{{$t('m.')}}</el-button> -->
      </div>
    </div>
  </div>
  <div class="contact-box">
    <div class="foot-main">
      <div class="tool-cell" style="margin-left:0px">
        <div class="title">{{$t('m.suitradede')}}</div>
        <div class="row cursor-pointer" @click="signuphrefwai">{{$t('m.Register')}}</div>
        <div class="row cursor-pointer" @click="signinhrefwai">{{$t('m.Starttrading')}}</div>
        <div class="row cursor-pointer" @click="hrefGoods('foreignExchangeTrading')">{{$t('m.rssstrjkdsf')}}</div>
        <div class="row cursor-pointer" @click="hrefGoods('contractDifference')">{{$t('m.rssqqstrjkdsf')}}</div>
        <!-- <div class="row cursor-pointer" @click="gotd">{{$t('m.Trade')}}</div>
        <div class="row cursor-pointer" @click="hrefGoods('download')">{{$t('m.DownloadCenter')}}</div>
        <div class="row cursor-pointer" @click="hrefGoods('news',4)">{{$t('m.FinancialNews')}}</div>
        <div class="row cursor-pointer" @click="hrefGoods('news',3)">{{$t('m.EconomicCalendar')}}</div> -->
      </div>
      <!-- <div class="tool-cell">
        <div class="title cursor-pointer">{{$t('m.mqwrplyc')}}</div>
        <div class="row cursor-pointer">{{$t('m.mqwrdbplyc')}}</div>
        <div class="row cursor-pointer" >{{$t('m.lpoobplyc')}}</div>
        <div class="row cursor-pointer">{{$t('m.lpoosnbplyc')}}</div>
        <div class="row cursor-pointer">{{$t('m.yuyutyc')}}</div>

      </div> -->
      <div class="tool-cell">
        <div class="title cursor-pointer" >{{$t('m.aboutbpt')}}</div>
        <div class="row cursor-pointer" @click="hrefGoods('whyBpt')">{{$t('m.tyyuyutyc')}}</div>
        <div class="row cursor-pointer" @click="hrefGoods('helpCenter')">{{$t('m.rtrjkdsf')}}</div>
        <div class="row cursor-pointer" @click="hrefGoods('legalDocument', 1)">{{$t('m.Legaldocument')}}</div>
        <!-- <div class="row cursor-pointer" @click="hrefGoods('legalDocument',2)">{{$t('m.PrivacyPoilcy')}}</div>
        <div class="row cursor-pointer" @click="hrefGoods('legalDocument',3)">{{$t('m.Disclaimer')}}</div>
        <div class="row cursor-pointer" @click="hrefGoods('legalDocument',4)">{{$t('m.RiskWarning')}}</div>
        <div class="row cursor-pointer" @click="hrefGoods('legalDocument',1)">{{$t('m.Useragreement')}}</div> -->
      </div>
      <div class="tool-cell" style="margin-right:0px">
        <div class="title">{{$t('m.Contactus')}}</div>
        <div class="row">Aegis Capital Corp.</div>
        <div class="row">1345 Avenue of the Americas, 27th Floor New York, NY 10105</div>
        <!-- <div class="row">中文热线：400000000</div> -->
        <!-- <div class="row">海外热线：480000000</div> -->
        <div class="row">E-mail：info@aegismk.com</div>
        <!-- <i class="el-icon-rt-tuite_twitter" @click="hrefwai(twitter)"></i>
        <i class="el-icon-rt-guge" @click="hrefwai(google)"></i>
        <i class="el-icon-rt-FaceBook" @click="hrefwai(face)"></i>
        <i class="el-icon-rt-ins1" @click="hrefwai(ins)"></i>
        <i class="el-icon-rt-telegram" @click="hrefwai(TELEGR)"></i>
        <img :src="imgon" alt="" class="mediu cursor-pointer" v-show="isMedu" @click="hrefwai(MEDIUM)" v-on:mouseover="isMedu = !isMedu" v-on:mouseout="isMedu = !isMedu">
        <img :src="imgout" alt="" class="mediu cursor-pointer" v-show="!isMedu" @click="hrefwai(MEDIUM)" v-on:mouseover="isMedu = !isMedu" v-on:mouseout="isMedu = !isMedu">
        <img :src="youtu" alt="" class="youtu cursor-pointer" v-show="isyou" @click="hrefwai(YOUTU)" v-on:mouseover="isyou = !isyou" v-on:mouseout="isyou = !isyou">
        <img :src="youtu2" alt="" class="youtu cursor-pointer" v-show="!isyou" @click="hrefwai(YOUTU)" v-on:mouseover="isyou = !isyou" v-on:mouseout="isyou = !isyou"> -->
      </div>
      <div class="desc">
        <!-- <img src="../assets/images/tan.png" alt=""> -->
        <p>{{$t('m.investment')}}</p>
        <p>{{$t('m.transactionsw')}}</p>
        <p>{{$t('m.bgwrreefg')}}</p>
        <!-- <p>{{$t('m.Parklifesdee')}}</p> -->
        <p>{{$t('m.accessibledee')}}</p>
      </div>
    </div>
  </div>
  <!-- <div class="record">
    <p>CDF证券交易咨询管理中心</p>
    <p>Copyright © 2010-2019 IRC GROUPS 版权所有不得转载 浙ICP备16053777号</p>
  </div> -->
</div>  
</template>

<script>
import BaseConfig from '@/common/baseConfig';
export default {
  name: 'headPage',
  data () {
    return {
      isMedu: true,
      isyou: true,
      dsflangval: '',
      imgon:require('../assets/images/medium-circle-fill.png'),
      imgout:require('../assets/images/medium-circle-fill2.png'),
      youtu:require('../assets/images/social_youtube.png'),
      youtu2:require('../assets/images/social_youtube2.png'),
      imgout:require('../assets/images/medium-circle-fill2.png'),
      activeIndex: '1',
      twitter: BaseConfig.TWITTER,
      google: BaseConfig.GOOGLE,
      face: BaseConfig.FACEBOOK,
      ins: BaseConfig.INSTAG,
      TELEGR: BaseConfig.TELEGR,
      MEDIUM: BaseConfig.MEDIUM,
      YOUTU: BaseConfig.YOUTU,
    }
  },
  mounted () {
      this.dsflangval = localStorage.getItem('dsflangval')

  },
  methods: {
    signinhrefwai () {
      window.open('https://www.aegismk.com/exchange.2x/signin?language=' + this.dsflangval);
    },
    signuphrefwai () {
      window.open('https://www.aegismk.com/exchange.2x/signup?language=' + this.dsflangval);
    },
    gotd(){
      window.open(BaseConfig.LOGIN_URL);
    },
    registered() {
        window.open(BaseConfig.REGIST_URL);
    },
    hrefGoods (href,label) {
      this.$router.push({
        name: href,
        params: {
          label: label
        }
      })
    },
    hrefwai (href) {
      window.open(href);
    },

  }
}
</script>
<style  lang="stylus" scoped>
  @import "~common/stylus/footPage.styl";
</style>



// WEBPACK FOOTER //
// src/components/footPage.vue